/** Matches backend Prisma/GraphQL MediaModule. Optional on all upload APIs. */
export enum MediaModule {
  Service = "SERVICE",
  Course = "COURSE",
  Event = "EVENT",
  Article = "ARTICLE",
  Story = "STORY",
  Ad = "AD",
  Company = "COMPANY",
  Occasion = "OCCASION",
  Case = "CASE",
  Group = "GROUP",
  Community = "COMMUNITY",
  Comment = "COMMENT",
  Post = "POST",
  Profile = "PROFILE",
  Document = "DOCUMENT",
  Support = "SUPPORT",
  Podcast = "PODCAST",
  Other = "OTHER",
}
